import { hasQrCodeLink, PostQrCode } from "@package/ui-apollo-components";
import { useSelectorWall } from "@package/ui-redux";
import { useTriviaContext } from "../context-trivia";
import { getContainerScaledSize } from "../trivia-layout";

// Built against master's PostQrCode/PostQrCodeStyle-less API (the QR styling work lives on a
// different branch). Isolated in its own component so that once that work lands, swapping to
// PostQrCodeBox + post.qrCodeStyle is a small change confined to this one file.
export function TriviaResultQrCode() {
  const { config, screen, containerSize } = useTriviaContext();
  const location = useSelectorWall((state) => state.wall.location);
  const profile = useSelectorWall((state) => state.wall.profile);
  const post = screen?.flyout?.post;

  if (
    !config.results.showQrCode ||
    !post ||
    !hasQrCodeLink(location, profile, post)
  ) {
    return null;
  }

  const size = getContainerScaledSize(containerSize, 0.3, 96);

  return (
    <div
      className="flex flex-col items-center p-[var(--trivia-space)]"
      style={{
        backgroundColor: config.theme.panelColor,
        borderRadius: "var(--trivia-radius)",
        inlineSize: "min-content",
      }}
    >
      {!!config.results.qrHeading && (
        <div
          className="pb-[var(--trivia-space)] text-center font-bold"
          style={{
            color: config.theme.buttonText,
            fontSize: "var(--trivia-text-body)",
          }}
        >
          {config.results.qrHeading}
        </div>
      )}
      <PostQrCode
        location={location}
        profile={profile}
        post={post}
        size={size}
      />
      {!!post.qrCodeText && (
        <div
          className="pt-[var(--trivia-space)] text-center font-bold"
          style={{
            color: config.theme.buttonText,
            fontSize: "var(--trivia-text-body)",
          }}
        >
          {post.qrCodeText}
        </div>
      )}
    </div>
  );
}
